import axios from 'axios';

let stack = new Map();
let lastKey = '';
export default {
  /**
   * Кладем шаг трассировки в стек
   * @param {number} action
   * @param {string} refs
   * @param {(string|Object)} value
   */
  traceInput: ({ action, refs, value }) => {
    if (parseInt(action, 10) > 0) {
      lastKey = JSON.stringify({action, refs});
      const obj = { action, refs, value };
      // obj.session_id = parseInt(sessionStorage.getItem('session_id'), 10);
      obj.session_id = window.session_id;
      obj.token = sessionStorage.getItem('token');
      const prevObj = stack.get(lastKey);

      obj.ts_start = prevObj ? prevObj.ts_start : Date.now();
      obj.ts_end = prevObj ? Date.now() : obj.ts_start;

      stack.set(lastKey, obj)
    }
  },

  /**
   * получаем последнюю добавленную запись
   */
  getLastTrace: () => stack.get(lastKey),

  /**
   * Отправляем массив шагов на сервер
   */
  sendTrace: async () => {
    if (stack.size > 0) {
      const sendingTracing = new Map(stack);
      stack.clear();
      try {
        await axios.post(process.env.VUE_APP_URL_TRACE, Array.from(sendingTracing.values()));
      } catch (e) {
        console.log(e);
        // потеряется информация о времени начала, альтернатива - ручная функция сравнения
        stack = new Map([...sendingTracing].concat([...stack]));
      }
    }
  },
};
